export default __webpack_public_path__ + "static/media/standing.138d7838.svg";